import React from "react";

const InputTextarea = ({ label, placeholder, required, id, name, error = "" }) => {
    return (
        <div className={`c-input ${error !== "" ? "c-input--error" : ""}`}>
            <label htmlFor={id}>{label}{required && "*"}</label>
            <textarea id={id} name={name} placeholder={placeholder} required={required}></textarea>
            <p className="c-input_error">{error !== "" ? error : " "}</p>
        </div>
    )
};

export default InputTextarea;